<p-toast></p-toast>
<div class="page-container">
    <!-- Sidebar -->
    <aside class="sidebar">
        <!-- Card 1: Nav Links -->
        <div class="sidebar-card nav-links">
            <div class="nav-item">
                <i class="pi pi-search"></i> College Search
            </div>
            <div class="nav-item active">
                <i class="pi pi-bookmark"></i> My Colleges
            </div>
        </div>

        <!-- Card 2: Progress Card (No Mentor Assigned) -->
        <div class="sidebar-card progress-card" style="position: relative; overflow: hidden;" *ngIf="!hasAssignedMentor">
            <img src="assets/images/browse-puzzle.png" style="position: absolute; top: 5px; left: 0; width: 70px;"
                alt="">
            <img src="assets/images/browse-line.png" style="position: absolute; top: 42px; left: 0; width: 100%;"
                alt="">
            <div class="progress-circle"
                style="position: relative; z-index: 1; background-color: #000086; border: none; color: white; top: 33px; ">
                <div class="circle-inner" style="color: #CDD22D;">{{ selectedSlots }}/{{ totalSlots }}</div>
            </div>
            <p class="progress-text" style="position: relative; z-index: 1; top: 36px;">You can still add {{ freeSlots
                }} more college
                for your
                direct apply</p>
            <button class="btn btn-navy" style="position: relative; z-index: 1; top: 33px;"
                (click)="browseColleges()">Browse colleges</button>
        </div>

        <!-- Card 2: Progress Card (Mentor Assigned) -->
        <div class="sidebar-card progress-card" style="position: relative; overflow: hidden;" *ngIf="hasAssignedMentor">
            <img src="assets/images/browse-puzzle.png" style="position: absolute; top: 5px; left: 0; width: 70px;"
                alt="">
            <img src="assets/images/browse-line.png" style="position: absolute; top: 42px; left: 0; width: 100%;"
                alt="">
            <div class="progress-circle"
                style="position: relative; z-index: 1; background-color: #000086; border: none; color: white; top: 33px; ">
                <div class="circle-inner" style="color: #CDD22D;">{{ gridColleges.length }}</div>
            </div>
            <p class="progress-text" style="position: relative; z-index: 1; top: 36px;">You have selected {{ gridColleges.length }} colleges , maybe you can find some more good fit</p>
            <button class="btn btn-navy" style="position: relative; z-index: 1; top: 33px;"
                (click)="browseAllColleges()">Browse colleges</button>
        </div>

        <!-- Card 3: CTA Card -->
        <div class="sidebar-card cta-card" style="padding: 20px !important;">
            <div class="cta-image" style="background: none; height: auto; position: relative;">
                <img src="assets/images/da-discuss.png" style="width: 100%; height: 131px;" alt="Discuss">
                <div
                    style="position: absolute; bottom: 0; left: 0; right: 0; height: 50px;  box-shadow: inset 2px -19px 16px #CDD22D;">
                </div>
            </div>
            <h3>Still confused?</h3>
            <p class="cta-subtext">Speak with an admissions expert who has helped <strong
                    style="color:#000086; font-weight:600 !important">2,400+ students</strong> get
                into top universities.</p>
            <button class="btn btn-navy" (click)="showClarityPopup = true">Enquire now</button>
        </div>
    </aside>

    <!-- Main Content -->
    <main class="main-content">

        <!-- Section 1: My Colleges (hidden when empty) -->
        <!-- Section 1: My Colleges — shown when user has saved colleges (gridColleges from myinstitute API) -->
        <div *ngIf="isLoading" style="display:flex; justify-content:center; align-items:center; min-height: 200px;">
            <p-progressSpinner strokeWidth="4" animationDuration=".8s"
                [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
        </div>

        <div *ngIf="!isLoading">
            <!-- GLOBAL EMPTY STATE -->
            <div *ngIf="directApplyColleges.length === 0 && gridColleges.length === 0" style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; min-height: 60vh; background: white; border-radius: 12px; margin-top: 20px;">
                <img src="assets/images/NoCollegeList.png" alt="NoCollegeListed" style="max-width: 300px; margin-bottom: 24px;">
                <h2 style="font-size: 24px; font-weight: 800; color: #000; text-transform: uppercase; margin-bottom: 16px;">
                    YOUR COLLEGE LIST IS EMPTY</h2>
                <p style="color: #64748b; font-size: 16px; margin-bottom: 32px; text-align: center; max-width: 550px; line-height: 1.5;">
                    Discover a wide range of colleges and courses tailored to your interests and career goals to find the perfect fit.
                </p>
                <button class="btn btn-navy" (click)="browseAllColleges()" style="color:#ffffff; padding: 12px 32px; font-size: 16px; font-weight: 600; border-radius: 8px; width: fit-content; min-width: 200px;">Browse Colleges</button>
            </div>

            <div *ngIf="directApplyColleges.length > 0 || gridColleges.length > 0">
                <!-- PAGE HEADER -->
                <div class="page-header-row">
                    <h1 class="page-main-title">MY COLLEGES</h1>
                    <span class="slots-badge">{{ selectedSlots }} of {{ totalSlots }} selected - {{ freeSlots }} slot{{ freeSlots !== 1 ? 's' : '' }} free</span>
                </div>

            <!-- TOP BOX: DIRECT APPLY COLLEGES -->
            <div class="white-box-container mb-4" *ngIf="!hasAssignedMentor">
                <div class="add-college-row">
                    <div class="add-info">
                        <span class="plus-icon"><i class="pi pi-plus" style="color:#0E1442"></i></span>
                        <div>
                            <div class="add-title">Add a college</div>
                            <div class="add-subtitle">{{ freeSlots }} slot{{ freeSlots !== 1 ? 's' : '' }} remaining
                                &mdash;
                                same flat platform fee</div>
                        </div>
                    </div>
                    <button class="btn btn-outline" (click)="browseColleges()">Browse &rarr;</button>
                </div>

                <div class="direct-apply-list">
                    <div class="list-item" *ngFor="let item of directApplyColleges; let i = index">
                        <div class="logo-container">
                            <img [src]="item.logo || 'assets/images/default-logo.png'" alt="Logo" class="list-logo">
                        </div>
                        <div class="list-details">
                            <div class="list-header">
                                <h3 class="list-name">{{ item.instituteName }}</h3>
                                <span class="pill">Partner</span>
                                <span class="pill" *ngIf="item.isPremiumApply" style="background-color: #000086; color: #CDD22D; border: 1px solid #000086; margin-left: 8px;">
                                    <i class="pi pi-star-fill" style="margin-right: 4px; font-size: 10px;"></i> Premium Applied
                                </span>
                            </div>
                            <p class="list-course">{{ item.courseName || 'N/A' }}</p>
                            <p class="list-meta"><i class="pi pi-calendar" style="margin-right: 4px; font-size:12px;"></i>
                                <span class="gap-2"><span style="margin-right:12px;"> Intake: {{ item.inTakeYear || 'N/A' }}</span>|<span style="margin-left:12px;">Mentor Deadline: {{ item.mentorDeadline }}</span></span>
                            </p>
                        </div>
                        <button class="btn-icon" (click)="removeDirectApply(i)"><i class="pi pi-trash"></i></button>
                    </div>
                </div>

                <!-- Loading state -->
                <div *ngIf="isDirectApplyLoading" class="direct-apply-loading">
                    <p-progressSpinner strokeWidth="4" animationDuration=".8s"
                        [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
                </div>

                <div class="apply-action" *ngIf="hasPendingColleges">
                    <button class="btn btn-large btn-navy width-220" (click)="applyNow()" style="color:#ffffff">Apply
                        now</button>
                    <p class="apply-info"><i class="pi pi-bolt" style="color: #F5A800; margin-right: 4px;"></i> Students who
                        use all <span class="highlight">5 slots</span> are <span class="highlight">2.3x more likely</span>
                        to land an admit. You have {{ freeSlots }} free.</p>
                </div>
            </div>

            <!-- BOTTOM BOX: SAVED COLLEGES -->
            <div class="white-box-container" *ngIf="gridColleges.length > 0">
                <div class="direct-apply-list">
                    <div class="list-item" *ngFor="let item of gridColleges; let i = index">
                        <div class="logo-container">
                            <img [src]="item.logo || 'assets/images/default-logo.png'" alt="Logo" class="list-logo">
                        </div>
                        <div class="list-details">
                            <div class="list-header">
                                <h3 class="list-name">{{ item.instituteName }}</h3>
                            </div>
                            <p class="list-course">{{ item.courseName || 'N/A' }}</p>
                            <p class="list-meta"><i class="pi pi-calendar" style="margin-right: 4px; font-size:12px;"></i>
                                <span class="gap-2"><span style="margin-right:12px;"> Intake: {{ item.inTakeYear || 'N/A' }}</span>|<span style="margin-left:12px;">Mentor Deadline: {{ item.mentorDeadline || 'N/A' }}</span></span>
                            </p>
                        </div>
                        <button class="btn-icon" (click)="removeCollege(i)"><i class="pi pi-trash"></i></button>
                    </div>
                </div>

                <div class="premium-apply-section mt-4">
                    <p class="premium-text" style="font-size: 12px; color: #64748b; text-align: center; max-width: 600px; margin: 0 auto 16px auto;">
                        Some students want more than a form, they want someone in their corner. Premium Apply pairs you with a
                        GradPilots mentor who guides you through every step, from shortlisting to final submission.
                    </p>
                    <div class="center">
                        <button class="btn btn-outline" routerLink="/portal/mentor-me" style="color:#000086; padding: 10px 24px;">Browse mentors</button>
                    </div>
                </div>
            </div>
            </div> <!-- End of content block when colleges exist -->
        </div>

    </main>
</div>
<app-clarity-call-popup [(visible)]="showClarityPopup" [contactPurpose]="12"></app-clarity-call-popup>